"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LargestMerchantInfo = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.LargestMerchantInfo = {
    priority: Number.MAX_VALUE,
    label: 'fields.payload.mor_entity_answers.largest_merchant_info.label',
    fallbackLabel: 'What is the share of your largest Merchants in comparison to your overall exposure portfolio, and its corresponding segments? Please provide the share (percentage of your total exposure portfolio that it represents), country of registration, and segment.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
